import React, { createContext, useContext, useMemo } from "react";

const ChannelTeamContext = createContext(null);

export default function ChannelTeamContextProvider({ children, ...props }) {
    const bag = useMemo(() => ({ ...props }), [Object.values(props)]);

    return (
        <ChannelTeamContext.Provider value={bag}>
            {children}
        </ChannelTeamContext.Provider>
    );
}

export function useChannelTeamCtx() {
    return useContext(ChannelTeamContext);
}
